import React from "react";
import classNames from "classnames";

import { State, Language } from "../core";
import { getString } from "./strings";

import "./Message.scss";

interface MessageProps {
  state: State;
  language: Language;
}
export const Message: React.FC<MessageProps> = React.memo(
  ({ state, language }) => {
    let text = getMessageText(state, language);
    let problem = isProblem(state);
    return (
      <div
        className={classNames("message", {
          isVisible: !!text,
          isProblem: problem
        })}
        dangerouslySetInnerHTML={{ __html: text || "" }}
      />
    );
  }
);

function getMessageText(state: State, language: Language) {
  if (state.state === "requestingMicrophone") {
    return getString(language, "waitingForMic");
  } else if (state.state === "microphoneRequestFailed") {
    return getString(language, "micError");
  } else if (state.state === "sendingFailed") {
    return getString(language, "sendingError");
  } else {
    return null;
  }
}

function isProblem(state: State) {
  return (
    state.state === "microphoneRequestFailed" || state.state === "sendingFailed"
  );
}
